import { render } from "./Reports.vue?vue&type=template&id=5d746ffe"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Organisation/Partials/Reports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d746ffe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d746ffe', __exports__)) {
    console.log('reload')
    api.reload('5d746ffe', __exports__)
  }
  
  module.hot.accept("./Reports.vue?vue&type=template&id=5d746ffe", () => {
    console.log('re-render')
    api.rerender('5d746ffe', render)
  })

}


export default __exports__